export const environment = {
  production: true,
 envName: 'prod'

  , URL_SAR: '/ms/gas'
  , URL_SAR_INICIAR: '/ms/gas/aplicativo/permiteIngresoGoogle/'
  , URL_LOGOUT: '/ingreso'
  , APP_ID : 'd800a0ca6a0c4d5b85be0120e62f22be'
  , APP_NOMBRE : 'UNIDAD PRÁCTICAS PRE PROFESIONALES DE HOSPITALIDAD'
  , envURL_CATERING: '/ms/catering/api/'
  , APP_URL: 'https://ppch.ucuenca.edu.ec'

  , URL_UNIDAD: 'https://sga.ucuenca.edu.ec/ms/unidad/api/unidad/'

  , URL_PERSONA: 'https://sga.ucuenca.edu.ec/ms/personas/api/persona/'
  , URL_API_ALFRESCO_DESCARGA: 'https://apibuscador.ucuenca.edu.ec/api/documentos/download/'
  , URL_API_ALFRESCO_SUBIDA: 'https://apibuscador.ucuenca.edu.ec/api/documentos/cargar_archivo/'
  , ID_CARPETA_FOTOS_PRODUCTOS_CATERING: '810e7fba-b1e0-4188-b87c-abaf9e4605bf'

  , URL_USUARIO: '/ms/gas/usuario/'
  , URL_LISTARPORIDAPLICATIVO: '/ms/gas/rol/listarPorIdAplicativo/'
  , URL_BUSCARPORIDUNIDAD: '/ms/gas/unidadAdministrativa/buscarPorId/'
  , URL_UNIDADADMINISTRATIVA: '/ms/gas/unidadAdministrativa/'
  , URL_USUARIOXROLXUNIDAD:  '/ms/gas/usuarioXRolXUnidad/'
  , ROL_JEFE_DEPENDENCIA_ID: "9cd2d968860a48998354f4ce3618badc"

  , envAmbiente: 'prod'
  , envLogueo: 'REDIS'
  , envURL_ACTIVIDAD: '/ms/redis/api/session/verificaSesion'

};
